/** PLACEHOLDER — replace before public launch (see docs/PLACEHOLDERS.md) */

const FORMATTED_ADDRESS = '19432 Pioneer Blvd, Cerritos, CA 90703'

export const site = {
  name: 'Rodeo Nails',
  /** Short line for JSON-LD / meta when a single phrase is needed */
  tagline: 'Manicures, pedicures, and nail care in Cerritos. Book online when it works for you.',
  /** Primary hero headline (Home) */
  heroHeadline: 'Luxury nail experience in Cerritos',
  /** One line under the hero headline */
  heroAccent: 'Comfortable chairs, clean stations, and finishes you will actually want to show off.',
  /** Brand statement block (Home) — minimal positioning copy */
  brandStatement:
    'A full-service nail salon committed to strict sanitation between every appointment and long-lasting, professional results.',
  city: 'Cerritos',
  region: 'CA',
  postalCode: '90703',
  streetAddress: '19432 Pioneer Blvd',
  addressLocality: 'Cerritos',
  addressRegion: 'CA',
  phone: '(562) 555-0199',
  websiteUrl: 'https://rodeonails.com',
  websiteDisplay: 'rodeonails.com',
  email: 'rodeonailsllc168@gmail.com',
  formattedAddress: FORMATTED_ADDRESS,
  /** External Google Maps search / directions for this address */
  googleMapsUrl: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(FORMATTED_ADDRESS)}`,
  /** Opening hours PLACEHOLDER */
  hours: [
    { day: 'Monday – Saturday', hours: '10:00 AM – 07:00 PM' },
    { day: 'Sunday', hours: 'Close' },
  ],
  social: {
    instagram: 'https://www.instagram.com/rodeonails.ca',
    facebook: 'https://www.facebook.com/',
    tiktok: 'https://www.tiktok.com/',
    yelp: 'https://www.yelp.com/',
  },
  /** E.164 for structured data (placeholder — match GBP before launch) */
  phoneE164: '+15625550199',
  /** Comma-separated SEO keywords (local) */
  seoKeywords:
    'luxury nail salon Cerritos, nail salon near me, gel x Cerritos, manicure Cerritos, pedicure Cerritos, modern nail salon',
  /** Open Graph locale (BCP 47 / OG format) */
  ogLocale: 'en_US',
  /** Twitter @handle for twitter:site (placeholder — align with live account before launch) */
  twitterSite: '@rodeonails',
  /** Default alt text when pages do not pass ogImageAlt */
  defaultOgImageAlt: 'Rodeo Nails salon interior and nail art in Cerritos',
} as const

export const navLinks = [
  { to: '/', label: 'Home' },
  { to: '/gallery', label: 'Gallery' },
  { to: '/gift-cards', label: 'Gift Cards' },
  { to: '/location#contact', label: 'Contact' },
  { to: '/faq', label: 'FAQ' },
] as const
